module.exports = __webpack_public_path__ + "static/media/axis-cosmic.feada4af.png";